import { service_translate_searches } from '@/services/translate/service_translate_searches';
import { LOCAL__grid2d_delete } from '@/state/grid2d/grid2d/LOCAL__grid2d_delete';
import { local_search_delete } from '@/state/search/local_search_delete';
import { store } from '@/state/store';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { local_workspace_child_entity_child_viewer_delete_by_entity_data } from '../child_entity/local_workspace_child_entity_child_viewer_delete_by_entity_data';

export const on_workspace_child_entity_delete_search = (ids: string[]) => {
  for (let entity_id of ids) {
    store.dispatch(local_workspace_child_entity_child_viewer_delete_by_entity_data([{ entity_id, entity_type: ENUM__workspace_entity.ENTITY_SEARCH }]));

    store.dispatch(LOCAL__grid2d_delete([entity_id]));
  }

  store.dispatch(local_search_delete(ids));

  service_translate_searches.on_entities_deleted(ids);
};
